import type { UsageServiceKind } from '@/api/creditsApi'

export const SERVICE_KINDS: UsageServiceKind[] = ['text', 'screenplay', 'storyboard', 'image', 'audio', 'video']

// 每工位独立配色，供用户侧与 admin 侧图表复用。
export const SERVICE_COLORS: Record<UsageServiceKind, string> = {
  text: '#60a5fa',
  screenplay: '#a78bfa',
  storyboard: '#2dd4bf',
  image: '#f59e0b',
  audio: '#34d399',
  video: '#fb7185',
}
